"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactSlick = require("react-slick");

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _videoReact = require("video-react");

var _idbReactIconlib = require("@identitybuilding/idb-react-iconlib");

var _idbReactIconlib2 = _interopRequireDefault(_idbReactIconlib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialFacebook = function SocialFacebook(props) {
  var year = void 0,
      month = void 0,
      day = void 0,
      time = void 0;
  if (props.post.created_time) {
    year = props.post.created_time.slice(0, 4);
    month = props.post.created_time.slice(5, 7);
    day = props.post.created_time.slice(8, 10);
    time = props.post.created_time.slice(11, 16);
  }
  var fbSlider = {
    dots: false,
    infinite: true,
    speed: 500,
    slidestoshow: 3,
    slidestoscroll: 3,
    arrows: true,
    variableWidth: false,
    rows: 1,
    autoplay: false,
    swipeToSlide: false,
    draggable: false
  };

  return _react2.default.createElement(
    "div",
    { className: "post" },
    _react2.default.createElement(
      "div",
      { className: "post-container" },
      _react2.default.createElement(
        "a",
        {
          href: "http://facebook.com/" + props.post.from.name + "-" + props.post.from.id + "/posts/" + props.post.id,
          className: "sn_logo",
          target: "_blank"
        },
        _react2.default.createElement(_idbReactIconlib2.default, { name: "Facebook" })
      ),
      _react2.default.createElement(
        "div",
        { className: "post-header" },
        _react2.default.createElement("img", { src: props.post.from.picture.data.url }),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "strong",
            null,
            props.post.from.name
          ),
          _react2.default.createElement(
            "p",
            { className: "post-date" },
            day + "/" + month + "/" + year + " at " + time
          )
        )
      )
    ),
    props.post.attachments && _react2.default.createElement(
      _react.Fragment,
      null,
      props.post.attachments.data[0].subattachments && _react2.default.createElement(
        _reactSlick2.default,
        fbSlider,
        props.post.attachments.data[0].subattachments.data.map(function (att) {
          return _react2.default.createElement(
            "div",
            {
              key: props.post.attachments.data[0].subattachments.data,
              className: "post-image__slider"
            },
            _react2.default.createElement("img", { src: att.media.image.src })
          );
        })
      ),
      !props.post.attachments.data[0].media.source && !props.post.attachments.data[0].subattachments && props.post.attachments.data[0].media.image.src && _react2.default.createElement(
        "div",
        { className: "post-image__container" },
        _react2.default.createElement("img", {
          className: "post-image",
          src: props.post.attachments.data[0].media.image.src
        })
      ),
      props.post.attachments.data[0].media.source && _react2.default.createElement(_videoReact.Player, {
        playsInline: true,
        poster: props.post.attachments.data[0].media.image.src,
        src: props.post.attachments.data[0].media.source
      })
    ),
    !props.post.attachments && _react2.default.createElement(
      "div",
      { className: "post-image__container" },
      _react2.default.createElement("img", { className: "post-image", src: props.defaultImage })
    ),
    _react2.default.createElement(
      "div",
      { className: "post-body" },
      !props.post.description && !props.post.message && props.post.story && _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          "p",
          { className: "post-body__title" },
          props.post.story
        ),
        _react2.default.createElement(
          "a",
          {
            href: "http://facebook.com/" + props.post.from.name + "-" + props.post.from.id + "/posts/" + props.post.id,
            target: "_blank"
          },
          "lees meer ",
          _react2.default.createElement(_idbReactIconlib2.default, { name: "ArrowDoubleRight" })
        )
      ),
      props.post.message && _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          "p",
          { className: "post-body__title" },
          props.post.message
        ),
        _react2.default.createElement(
          "a",
          {
            href: "http://facebook.com/" + props.post.from.name + "-" + props.post.from.id + "/posts/" + props.post.id,
            target: "_blank"
          },
          "lees meer ",
          _react2.default.createElement(_idbReactIconlib2.default, { name: "ArrowDoubleRight" })
        )
      ),
      props.post.description && _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          "p",
          { className: "post-body__title" },
          props.post.description
        ),
        _react2.default.createElement(
          "a",
          {
            href: "http://facebook.com/" + props.post.from.name + "-" + props.post.from.id + "/posts/" + props.post.id,
            target: "_blank"
          },
          "lees meer ",
          _react2.default.createElement(_idbReactIconlib2.default, { name: "ArrowDoubleRight" })
        )
      )
    )
  );
};

exports.default = SocialFacebook;